import { ReactComponent as NeoniLogo } from '../../assets/neoni-logo.svg'

type LogoWithBetaProps = {
	className?: string
	// Horizontal margin goes here, not on the logo, so the Beta 2 label stays aligned with the logo's right edge.
	wrapperClassName?: string
}

export default function LogoWithBeta({ className, wrapperClassName }: LogoWithBetaProps) {
	return (
		<div className={`relative inline-block ${wrapperClassName ?? ''}`}>
			<NeoniLogo className={`text-charcoal-050 hover:text-white transition-colors ${className ?? ''}`} />
			<span className="absolute text-charcoal-300 text-xs whitespace-nowrap leading-none" style={{ right: '0px', bottom: '-3px' }}>
				Beta 2
			</span>
		</div>
	)
}
